import { gql } from "@apollo/client";

export default gql`
  mutation ToggleEnrichedProduct($productId: ObjectId!) {
    toggleEnrichedProduct(id: $productId) {
      _id
      slug
      enrichedProfile
    }
  }
`;
